<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Review By
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Status
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
      >
        Date Email Sent
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
      >
        Date Created
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right w-0"
      >
        <span class="sr-only">Actions</span>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
